<template>
  <wo-layout>
    <po-error-display :value="error" mod-scroll />
    <form autocomplete="off">
      <wo-card :title="$t('general.info')">
        <wo-properties mod-horizontal mod-bordered v-focus="true">
          <wo-properties-label><wo-label v-t="'company.name'"></wo-label></wo-properties-label>
          <wo-properties-value><po-input-field name="name" v-model="pending.name" /></wo-properties-value>

          <wo-properties-label><wo-label v-t="'company.brand'"></wo-label></wo-properties-label>
          <wo-properties-value><po-selector v-model="pending.brand" :options="brands" /></wo-properties-value>

          <wo-properties-label><wo-label v-t="'company.accountNumber'"></wo-label></wo-properties-label>
          <wo-properties-value><po-input-field name="accountNumber" v-model="pending.account_number" /></wo-properties-value>
        </wo-properties>
      </wo-card>
      <po-confirmation-buttons @confirm="confirm" @cancel="emitCancel" :valid="valid" />
    </form>
  </wo-layout>
</template>

<script>

import editor from '@/mixins/editor'

import { BrandEnum } from '@/model/environment'
import { Company } from '@/model/company'
import { companyRepository } from '@/repository/company'
import { mapState } from 'vuex'

export default {
  mixins: [ editor ],
  props: {
    value: Company
  },
  computed: mapState({
    brands: () => BrandEnum.values,
    valid () {
      const c = this.pending
      return c.name
    }
  }),
  created () {
    this.pending = new Company(this.value)
  },
  methods: {
    confirm ({ detail }) {
      const action = this.newEntity ? companyRepository.create : companyRepository.update
      this.$store.dispatch(action, { entity: this.pending })
        .then(this.emitInput, this.editFailed)
        .finally(detail.resolve)
    }
  }
}
</script>
